module.exports = __webpack_public_path__ + "img/icon_3.f6f92662.png";